import { defineMessages } from "react-intl";

const STEPPER = "stepper";

const stepperMessages = defineMessages({
  currentStepLabel: {
    id: `${STEPPER}.current-step-label`,
    defaultMessage: "{title}, step {step} of {total}.",
    description:
      "aria-label telling the user what step they are on in the current workflow."
  }
});

export default stepperMessages;
